'use client'

import { useEffect } from 'react'
import {
	fixTextLinkAriaLabels,
	startAccessiBeLabelFixLoop,
} from '@/lib/accessibility'

export default function AccessiBeAriaFix() {
	useEffect(() => {
		let frameId = 0
		const stopLoop = startAccessiBeLabelFixLoop()

		const scheduleFix = () => {
			cancelAnimationFrame(frameId)
			frameId = requestAnimationFrame(() => {
				fixTextLinkAriaLabels(document.body)
			})
		}

		const observer = new MutationObserver(scheduleFix)
		observer.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: [
				'aria-label',
				'aria-labelledby',
				'data-custom-button-processed',
			],
		})

		return () => {
			cancelAnimationFrame(frameId)
			stopLoop()
			observer.disconnect()
		}
	}, [])

	return null
}
